import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(DialogActions)(({ theme }) => ({
  background: theme.palette.commonground.main,
  color: theme.palette.commonground.contrastText,
  padding: theme.spacing(1.5),
  paddingRight: theme.spacing(2),
}));

const OmniDialogActions = props => {
  const { children, ...other } = props;
  return <CustomizedComponent {...other}>{children}</CustomizedComponent>;
};

export default OmniDialogActions;
